import type { GetLayoutTypes } from './types';
import { getLayoutPreviewImage } from './utils';

interface LayoutPreviewProps {
  data: GetLayoutTypes;
  layoutTypeValue: string;
}

const LayoutPreview = ({ data, layoutTypeValue }: LayoutPreviewProps) => {
  return (
    <div>
      <div className="sticky top-0">
        {layoutTypeValue ? (
          <div className="bg-card rounded-md border p-4">
            {getLayoutPreviewImage(layoutTypeValue) ? (
              <img
                alt={`Preview of ${
                  data.layoutTypes.find(lt => lt.value === layoutTypeValue)
                    ?.name ?? layoutTypeValue
                } layout`}
                className="h-auto w-full rounded"
                src={getLayoutPreviewImage(layoutTypeValue) ?? undefined}
              />
            ) : (
              <div className="text-muted-foreground flex h-64 items-center justify-center text-sm">
                Preview image not available
              </div>
            )}
          </div>
        ) : (
          <div className="text-muted-foreground bg-card flex h-64 items-center justify-center rounded-md border text-sm">
            Select a layout type to see preview
          </div>
        )}
      </div>
    </div>
  );
};

export default LayoutPreview;
